import { StorageTimeType } from './enum/storage-time-type';
import { OptionItem } from '../../../diagram/utils/option-item';
var StorageTimeHelper = /** @class */ (function () {
    function StorageTimeHelper() {
    }
    StorageTimeHelper.getStorageTimeTypes = function () {
        return [
            new OptionItem(StorageTimeType.SixMonths, 'SixMonths')
        ];
    };
    return StorageTimeHelper;
}());
export { StorageTimeHelper };
